function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 8a1 1 0 011-1h28a1 1 0 110 2H2a1 1 0 01-1-1zM5 16a1 1 0 011-1h20a1 1 0 110 2H6a1 1 0 01-1-1zM10 24a1 1 0 011-1h10a1 1 0 110 2H11a1 1 0 01-1-1z",
  fill: "currentColor"
})));